import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, Spinner } from "reactstrap";
import EmpresaContext from "../../../../contexts/Empresa";
import api from "../../../../services/api";
import CardForm from "./CardForm";
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
// @ts-ignore
import NotificationAlert from "react-notification-alert";

interface CardDetailsPageProps {
  match: {
    params: {
      id: string;
    };
  };
  history: any;
}

const CardDetailsPage: React.FC<CardDetailsPageProps> = (props) => {
  const cardId = props.match.params.id;
  const { empresaSelecionada } = useContext(EmpresaContext);
  const notificationAlertRef = React.useRef<any>(null);

  const [loading, setLoading] = useState(true);
  const [card, setCard] = useState<any>(null);
  const [estagios, setEstagios] = useState<any[]>([]);
  const [titulo, setTitulo] = useState('');
  const [tituloFocused, setTituloFocused] = useState(false);
  const tituloInputRef = React.useRef<HTMLInputElement>(null);

  const notify = (type: string, msg: string) => {
    if (notificationAlertRef.current) {
      notificationAlertRef.current.notificationAlert({
        place: "tc",
        message: <div className="alert-text"><span data-notify="message">{msg}</span></div>,
        type: type,
        icon: "ni ni-bell-55",
        autoDismiss: 7,
      });
    }
  };

  useEffect(() => {
    if (empresaSelecionada && cardId) {
      loadCardAndStages();
    }
  }, [empresaSelecionada, cardId]);

  async function loadCardAndStages() {
    setLoading(true);
    try {
      const cardRes = await api.get(`/common/empresas/${empresaSelecionada?.id}/cards/${cardId}`);
      const cardData = cardRes.data;
      setCard(cardData);
      setTitulo(cardData.titulo || '');

      if (cardData.funil_id) {
        const stagesRes = await api.get(`/common/empresas/${empresaSelecionada?.id}/funis/${cardData.funil_id}/estagios`);
        setEstagios(stagesRes.data);
      }
    } catch (error) {
      console.error(error);
      notify('danger', 'Erro ao carregar detalhes do card.');
    }
    setLoading(false);
  }

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <SimpleHeader
        name={titulo || 'Detalhes do Card'}
        parentName={card?.funil?.nome || 'Pipelines'}
        {...props}
      />

      <div className="w-100">
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                  {/* Wrapper que dá largura natural ao input via span oculto */}
                  <div style={{ position: 'relative', display: 'inline-block', minWidth: '60px' }}>
                    <span
                      aria-hidden
                      style={{
                        visibility: 'hidden',
                        whiteSpace: 'pre',
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        display: 'block',
                        padding: '0 2px 2px 0',
                      }}
                    >
                      {titulo || 'Título do card'}
                    </span>
                    <input
                      ref={tituloInputRef}
                      value={titulo}
                      onChange={e => setTitulo(e.target.value)}
                      placeholder="Título do card"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        color: '#32325d',
                        background: 'transparent',
                        border: 'none',
                        borderBottom: `2px solid ${tituloFocused ? '#5e72e4' : 'transparent'}`,
                        outline: 'none',
                        padding: '0',
                        transition: 'border-color 0.15s ease',
                      }}
                      onFocus={() => setTituloFocused(true)}
                      onBlur={() => setTituloFocused(false)}
                    />
                  </div>
                  <i
                    className="fas fa-pencil-alt"
                    onClick={() => tituloInputRef.current?.focus()}
                    style={{
                      fontSize: '0.75rem',
                      color: tituloFocused ? '#5e72e4' : '#adb5bd',
                      cursor: 'pointer',
                      transition: 'color 0.15s ease',
                    }}
                  />
                </div>
              </CardHeader>
              <CardBody className='py-0 px-0'>
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="mt-2 text-muted">Carregando dados do card...</p>
                  </div>
                ) : card ? (
                  <CardForm
                    key={card.id}
                    card={card}
                    funilId={card.funil_id}
                    estagios={estagios}
                    tituloExterno={titulo}
                    onSuccess={() => {
                      notify('success', 'Card salvo com sucesso!');
                      loadCardAndStages();
                    }}
                    onCancel={() => props.history.goBack()}
                    notify={notify}
                  />
                ) : (
                  <div className="text-center py-5">
                    <p className="text-muted">Card não encontrado.</p>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CardDetailsPage;
